import { gql } from "@apollo/client";

const CREATE_BANNER = gql`
  mutation createBanner(
    $platformPublicId: String!
    $headLine: String!
    $subHeadLine: String!
    $buttonText: String!
    $buttonLink: String!
    $primaryColor: String!
    $status: String!
    $role: String
    $sports: [Int!]
    $images: [Upload!]
    $addedBy: Int
  ) {
    createBanner(
      createBannerInput: {
        platformPublicId: $platformPublicId
        headLine: $headLine
        subHeadLine: $subHeadLine
        buttonText: $buttonText
        buttonLink: $buttonLink
        primaryColor: $primaryColor
        status: $status
        role: $role
        sports: $sports
        images: $images
        addedBy: $addedBy
      }
    ) {
      id
    }
  }
`;

export default CREATE_BANNER;
